import React, { CSSProperties } from 'react';

import { useHistory } from 'react-router';

import ProfilePicture from 'clean/components/common/ProfilePicture/ProfilePicture';

import './ChatItem.scoped.scss';

interface Chats {
  id: string;
  title: string;
  name: string;
  time: string;
  message: string;
  type: string;
  user_id: string;
}

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  content?: Chats;
}

const ChatItem: React.FC<Props> = ({ style, content }) => {
  const history = useHistory();
  const handleClick = () => {
    history.push(`/chat?id=${content.id}`);
  };

  return (
    <div className="chat-item-container pointer" style={style} onClick={handleClick}>
      <div className="avatar">
        <div className="student avata">
          <ProfilePicture userId={content.user_id} />
        </div>
      </div>
      <div className="content">
        <h4>
          <span>{content?.type === 'GROUP' && content?.title}</span>{' '}
          {content?.type === 'GROUP' && '|'} {content?.name}{' '}
        </h4>
        <span className="time">{content?.time}</span>

        <p className="message">{content?.message}</p>
      </div>
    </div>
  );
};

export default ChatItem;
